import React, { useEffect, useRef, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Alert, Button, Card, CardBody, Row } from "reactstrap";
import { urlCreaFacturacionAP, urlListarCoberturasAp, urlListarProductosAp, urlObtenerPlanesAP } from "../../constants/urls";
import ContainerApFacturacion from "./ContainerApFacturacion";
import FormularioPlanes from "./FormularioPlanes";
import { useToasts } from 'react-toast-notifications';
import { useLocation, useHistory } from 'react-router-dom';
import ConfirmPopup from '../Generales/ConfirmPopup';

const toNumber = (v, def = 0) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : def;
};

const buildImpuestosArray = (base) => {
  const b = toNumber(base, 0);
  return [
    { nombre: 'Superintendencia', porcentaje: 3.5, valor: +(b * 0.035).toFixed(2) },
    { nombre: 'Seguro campesino', porcentaje: 0.5, valor: +(b * 0.005).toFixed(2) }
  ];
};

const ComponentApFacturacionPlanes = (props) => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const [loading, setLoading] = useState(false);
  const [planes, setPlanes] = useState([]);
  const [planIndividual, setPlanIndividual] = useState(false);
  const [ramo, setRamo] = useState(null);
  const [subRamo, setSubRamo] = useState(null);

  // Tipo de emisión
  const [tipoEmision, setTipoEmision] = useState('');
  const [tipoEmisionError, setTipoEmisionError] = useState(false);

  const [erroresCoberturas, setErroresCoberturas] = useState(false);
  // Edad global (aplica a todos los planes)
  const [edadMinimaGlobal, setEdadMinimaGlobal] = useState('');
  const [edadMaximaGlobal, setEdadMaximaGlobal] = useState('');

  // Producto (select)
  const [productosOptions, setProductoOptions] = useState('');
  const [producto, setProducto] = useState('');
  const { addToast } = useToasts();

  const refPlanes = useRef();

  // Estado para el popup de confirmación
  const [confirmPopup, setConfirmPopup] = useState({
    isOpen: false,
    mensaje: '',
    onConfirm: null,
  });

  useEffect(() => {
    if (!id) history.push('/lista-cotizadores');
  }, [id, history]);

  useEffect(() => {
    recuperarPlanes();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    recuperarProductos();
  }, [ramo]);

  const recuperarPlanes = async () => {
    setLoading(true);
    try {
      const response = await fetch(urlObtenerPlanesAP, {
        method: 'POST',
        body: JSON.stringify({ id }),
      });
      const json = await response.json();

      if (json && json.transaccion) {
        // Preferimos planIndividual si existe; si no, usamos blanket
        var flagIndividual = json.blanket;
        console.log("🚀 ~ recuperarPlanes ~ flagIndividual:", flagIndividual)

        // Planes base
        var planesServer = Array.isArray(json.planes) ? json.planes : [];

        // Si hay asistenciasGlobal y es múltiple, inyectamos en el primer plan
        var planesIniciales = planesServer;
        var esMultiple = !flagIndividual;
        if (
          esMultiple &&
          Array.isArray(json.asistenciasGlobal) &&
          json.asistenciasGlobal.length > 0 &&
          Array.isArray(planesServer) &&
          planesServer.length > 0
        ) {
          planesIniciales = planesServer.map(function (p, i) {
            if (i === 0) {
              var yaTieneAsist = Array.isArray(p.asistencias) && p.asistencias.length > 0;
              return yaTieneAsist ? p : Object.assign({}, p, { asistencias: json.asistenciasGlobal });
            }
            return p;
          });
        }

        setPlanes(planesIniciales);
        setPlanIndividual(flagIndividual);
        setSubRamo(json.subRamo || null);
        setRamo(json.ramo || null);

        if (json.tipoEmision) {
          setTipoEmision(String(json.tipoEmision));
        }

        if (json.edadMinimaGlobal !== undefined && json.edadMinimaGlobal !== null && String(json.edadMinimaGlobal) !== '') {
          setEdadMinimaGlobal(String(json.edadMinimaGlobal));
        }
        if (json.edadMaximaGlobal !== undefined && json.edadMaximaGlobal !== null && String(json.edadMaximaGlobal) !== '') {
          setEdadMaximaGlobal(String(json.edadMaximaGlobal));
        }

        // Producto puede venir como string o como objeto { value, label }
        if (typeof json.producto !== 'undefined' && json.producto !== null) {
          var prodValue = '';
          if (typeof json.producto === 'object') {
            if (typeof json.producto.value !== 'undefined' && json.producto.value !== null) {
              prodValue = json.producto.value;
            } else {
              prodValue = '';
            }
          } else {
            prodValue = json.producto;
          }
          if (typeof prodValue !== 'undefined' && prodValue !== null && String(prodValue) !== '') {
            setProducto(String(prodValue));
          }
        }
        // Restore from sessionStorage when coming back (survives any navigation method)
        const rawStorage = sessionStorage.getItem(`ap_planes_form_${id}`);
        if (rawStorage) {
          try {
            const savedState = JSON.parse(rawStorage);
            if (savedState.tipoEmision) setTipoEmision(savedState.tipoEmision);
            if (savedState.producto) setProducto(savedState.producto);
            if (savedState.edadMinimaGlobal !== undefined) setEdadMinimaGlobal(savedState.edadMinimaGlobal);
            if (savedState.edadMaximaGlobal !== undefined) setEdadMaximaGlobal(savedState.edadMaximaGlobal);
            if (Array.isArray(savedState.planes) && savedState.planes.length > 0) {
              setPlanes(savedState.planes);
            }
          } catch (_) {}
        }
      }
    } catch (e) {
      addToast('Error, recuperar Planes', { appearance: 'error' });
    }
    setLoading(false);
  };

  const recuperarProductos = async () => {
    // si no hay ramo/subRamo válidos, no llamamos
    if (!ramo || !subRamo || !ramo.value || !subRamo.value) {
      setProductoOptions([]);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ramo: String(ramo.value),
        subRamo: String(subRamo.value)
      };

      const response = await fetch(urlListarProductosAp, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response || !response.ok) {
        const status = response ? response.status : 'SIN_RESPUESTA';
        addToast('No se pudo obtener productos (' + status + ')', { appearance: 'warning' });
        setProductoOptions([]);
        return;
      }

      let json;
      try {
        json = await response.json();
      } catch (e) {
        addToast('Respuesta inválida del servidor (JSON)', { appearance: 'warning' });
        setProductoOptions([]);
        return;
      }

      if (json && json.transaccion && Array.isArray(json.productos)) {
        setProductoOptions(json.productos);
      } else {
        setProductoOptions([]);
        addToast(
          (json && json.mensaje) ? json.mensaje : 'Sin productos para el ramo/subramo seleccionados',
          { appearance: 'info' }
        );
      }
    } catch (error) {
      addToast('No fue posible conectar al servidor (productos).', { appearance: 'error' });
      setProductoOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const aplicarCambioTipoEmision = (nuevo) => {
    setTipoEmision(nuevo);
    setTipoEmisionError(false);
    setPlanIndividual(false);
    if (nuevo === 'personalizable') {
      setProducto(0);
    }
    setPlanes([]);
    setEdadMinimaGlobal('');
    setEdadMaximaGlobal('');
  };

  const manejarCambioTipoEmision = (e) => {
    const nuevo = e.target.value;

    const tieneDatos = planes.some(p =>
      (p.nombre && String(p.nombre).trim() !== '') ||
      (p.coberturas && p.coberturas.length > 0) ||
      (p.asistencias && p.asistencias.length > 0)
    );

    if (tieneDatos || tipoEmision !== '') {
      setConfirmPopup({
        isOpen: true,
        mensaje: 'Esta configuración eliminará las coberturas y asistencias previamente ingresadas. ¿Está seguro que desea continuar?',
        onConfirm: () => aplicarCambioTipoEmision(nuevo),
      });
      return;
    }

    aplicarCambioTipoEmision(nuevo);
  };

  const manejarCambioProducto = (e) => {
    const nuevo = e.target.value;

    let planesActuales = planes;
    if (refPlanes.current && typeof refPlanes.current.obtenerDatos === "function") {
      const formDatos = refPlanes.current.obtenerDatos(true);
      if (formDatos) {
        planesActuales = formDatos;
      }
    }

    // Si ya hay planes con datos, no permitir el cambio
    if (Array.isArray(planesActuales) && planesActuales.some(p =>
    (p && (
      (p.nombre && String(p.nombre).trim() !== '') ||
      (Array.isArray(p.coberturas) && p.coberturas.length > 0) ||
      (Array.isArray(p.asistencias) && p.asistencias.length > 0)
    ))
    )) {
      addToast('Debe borrar primero los planes existentes del producto actual para cambiar de producto.', { appearance: 'warning' });
      return;
    }

    setProducto(nuevo);
    setPlanes([]); // limpia valores iniciales
    setEdadMinimaGlobal('');
    setEdadMaximaGlobal('');
  };

  const guardarAmbosYContinuar = async () => {
    setLoading(true);

    if (!tipoEmision) {
      setTipoEmisionError(true);
      addToast("Debe seleccionar un tipo de emisión", { appearance: "warning" });
      setLoading(false);
      return;
    }

    // Obtener datos desde el ref
    let datosPlanes = null;

    if (refPlanes.current && typeof refPlanes.current.obtenerDatos === "function") {
      datosPlanes = refPlanes.current.obtenerDatos();
    }

    // Validación mínima requerida
    if (!datosPlanes || !Array.isArray(datosPlanes) || datosPlanes.length === 0) {
      addToast("Debe ingresar al menos un plan (y correcciones si hay errores)", { appearance: "warning" });
      setLoading(false);
      return;
    }

    //validacion coberturas con valores validos
    let hayErroresCoberturas = false;
    datosPlanes.forEach(plan => {
      (plan.coberturas || []).forEach(cobertura => {
        if (tipoEmision !== 'personalizable' && (cobertura.prima <= 0 || cobertura.sumaAsegurada <= 0)) {
          hayErroresCoberturas = true;
        }
      });
    });
    
    setErroresCoberturas(hayErroresCoberturas);

    if (hayErroresCoberturas && tipoEmision != "producto") {
      addToast("Debe ingresar valores validos para las coberturas", { appearance: "warning" });
      setLoading(false);
      return;
    }

    // Helpers locales
    const sumByPrima = (lista) =>
      (Array.isArray(lista) ? lista : []).reduce((acc, it) => acc + toNumber(it && it.prima, 0), 0);

    const round2 = (n) => Number(toNumber(n, 0).toFixed(2));

    // ===== Cálculos por plan (base = coberturas + asistencias)
    const totalesPorPlan = datosPlanes.map((p) => {
      const primaCoberturas = (Array.isArray(p.coberturas) ? p.coberturas : [])
        .reduce((acc, c) => acc + toNumber(c && c.prima, 0), 0);

      // Si es múltiple, obtenerDatos() ya replicó asistenciasGlobal en cada plan.
      const totalAsistencias = sumByPrima(p.asistencias);


      const primaTotal = primaCoberturas + 1.04;
      const basePlan = primaTotal + totalAsistencias;      // base del 4%
      const impuestos4 = primaTotal * 0.04;
      const totalPlanPersona = basePlan + impuestos4;

      return {
        nombre: p.nombre || '',
        primaNeta: round2(primaCoberturas),
        primaTotal: primaTotal,        // coberturas sin 4%
        asistencias: round2(totalAsistencias),       // asistencias sin 4%
        impuestos4: round2(impuestos4),              // 4% de (coberturas + asistencias)
        totalPlanPersona: round2(totalPlanPersona)   // (coberturas + asistencias) * 1.04
      };
    });

    // ===== Totales globales
    const sumPrimaNeta = totalesPorPlan.reduce((acc, t) => acc + toNumber(t.primaNeta, 0), 0);
    const sumAsist = totalesPorPlan.reduce((acc, t) => acc + toNumber(t.asistencias, 0), 0);
    const baseGlobalImpuesto = sumPrimaNeta + sumAsist;               // base global del 4%
    const impuestosPersona = baseGlobalImpuesto * 0.04;
    const subtotalPersona = baseGlobalImpuesto;                       // base sin 4%
    const totalPersona = baseGlobalImpuesto * 1.04;

    const totalesGlobales = {
      subtotalPersona: round2(subtotalPersona),   // Σ(coberturas) + Σ(asistencias)
      impuestosPersona: round2(impuestosPersona), // 4% de la base global
      totalPersona: round2(totalPersona)          // base * 1.04
    };

    // ===== Impuestos GLOBAL para payload (usando NUEVA base global)
    const impuestosGlobal = buildImpuestosArray(baseGlobalImpuesto);

    // Utilidad para clonar los impuestos y no compartir referencias
    const clonarImpuestos = (arr) => (Array.isArray(arr) ? arr.map(i => ({ ...i })) : []);

    // ===== Enriquecer cada plan: agregar condicion + copia de impuestosGlobal
    const planesConCondicion = datosPlanes.map((p, idx, arr) => {
      let condicion = { aplica: false };

      if (p && p.esCondicional === "si") {
        const depIdx = (p.planCondicion !== "" && p.planCondicion !== null && typeof p.planCondicion !== "undefined")
          ? Number(p.planCondicion)
          : null;

        condicion = {
          aplica: true,
          tipo: p.tipoCondicional || "",
          valor: toNumber(p.valorCondicional, 0),
          dependeDePlanIndex: Number.isFinite(depIdx) ? depIdx : null,
          dependeDePlanNombre: (Number.isFinite(depIdx) && arr[depIdx])
            ? ("Plan " + (depIdx + 1) + (arr[depIdx].nombre ? (": " + arr[depIdx].nombre) : ""))
            : ""
        };
      }

      // Merge plano y anexos
      const merged = { ...p };
      merged.condicion = condicion;

      // Guardar COPIA de los impuestos globales en cada plan
      merged.impuestos = clonarImpuestos(impuestosGlobal);

      return merged;
    });

    try {
      const body = {
        idCarrito: id,
        tipoEmision: tipoEmision,
        producto: producto,
        planIndividual: planIndividual,
        edadMinimaGlobal: edadMinimaGlobal,
        edadMaximaGlobal: edadMaximaGlobal,

        // Planes enriquecidos
        planes: planesConCondicion,

        // === Totales que pides guardar ===
        totalesPorPlan,            // Array con totales por plan
        totalesGlobales,           // Objeto con totales globales

        // === Impuestos SOLO a nivel global (con la nueva base) ===
        impuestos: impuestosGlobal
      };

      const response = await fetch(urlCreaFacturacionAP, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          pasoCarrito: "informacion_planes",
          ...body
        })
      });

      const json = await  response.json();

      if (json && json.transaccion) {
        addToast("Planes guardados correctamente", { appearance: "success" });
        sessionStorage.setItem(`ap_planes_form_${id}`, JSON.stringify({ tipoEmision, producto, edadMinimaGlobal, edadMaximaGlobal, planes: datosPlanes }));
        history.push({ pathname: props.datosCotizador.urlSiguiente, search: `?id=${id}` });
      } else {
        addToast((json && json.mensaje) || "Error al guardar", { appearance: "error" });
      }
    } catch (error) {
      addToast("Error al guardar los datos", { appearance: "error" });
    }

    setLoading(false);
  };




  return (
    <ContainerApFacturacion paso="planes" titulo={props.datosCotizador.titulo}>
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={loading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Obteniendo datos..."
            >
              {/* ---------- TIPO DE EMISIÓN ---------- */}
              <Row>
                <h4 style={{ fontWeight: "bold" }} className="mb-3">
                  Tipo de Emisión
                </h4>
              </Row>
              <Row className="mb-4">
                <div className="col-md-6">
                  <label className="form-label">
                    Tipo de emisión <span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-control${tipoEmisionError ? ' is-invalid' : ''}`}
                    value={tipoEmision}
                    onChange={manejarCambioTipoEmision}
                  >
                    <option value="">Seleccione un tipo de emisión</option>
                    <option value="producto">Basado en producto</option>
                    <option value="personalizable">Personalizable - sin producto</option>
                  </select>
                  {tipoEmisionError && (
                    <div className="invalid-feedback">Campo obligatorio*</div>
                  )}
                </div>
              </Row>

              {/* ---------- PLANES ---------- */}
              {tipoEmision === '' ? (
                <Alert color="info">
                  Primero seleccione un <b>tipo de emisión</b> para configurar los planes.
                </Alert>
              ) : (
                <>
                  <Row>
                    <h4 style={{ fontWeight: "bold" }} className="mb-5">
                      {planIndividual ? "Datos del Plan" : "Datos de Planes"}
                    </h4>
                  </Row>
                  <FormularioPlanes
                    key={`planes-${tipoEmision}`}
                    ref={refPlanes}
                    planIndividual={planIndividual}
                    values={planes}
                    urlCoberturas={urlListarCoberturasAp}
                    ramo={ramo}
                    subRamo={subRamo}
                    tipoEmision={tipoEmision}
                    productosOptions={productosOptions}
                    edadMinimaGlobal={edadMinimaGlobal}
                    edadMaximaGlobal={edadMaximaGlobal}
                    onEdadGlobalChange={(min, max) => { setEdadMinimaGlobal(min); setEdadMaximaGlobal(max); }}
                  />
                </>
              )}

              <Card>
                <CardBody style={{ display: "flex", justifyContent: "space-between" }}>
                  <Button
                    onClick={() =>
                      props.history.push({
                        pathname: props.datosCotizador.urlRegresar,
                        search: `?id=${id}`,
                      })
                    }
                    style={{ backgroundColor: "#001871", color: "white", border: "none" }}
                  >
                    <i className="fa fa-chevron-circle-left" /> &nbsp;REGRESAR
                  </Button>
                  <Button
                    onClick={guardarAmbosYContinuar}
                    style={{ backgroundColor: "#001871", color: "white", border: "none" }}
                  >
                    CONTINUAR &nbsp;<i className="fa fa-chevron-circle-right" />
                  </Button>
                </CardBody>
              </Card>
            </LoadingScreen>
          </div>
        </div>
      </main>
      {/* ---------- POPUP DE CONFIRMACIÓN REUTILIZABLE ---------- */}
      <ConfirmPopup
        isOpen={confirmPopup.isOpen}
        toggle={() => setConfirmPopup(prev => ({ ...prev, isOpen: false }))}
        mensaje={confirmPopup.mensaje}
        textoConfirmar='Sí'
        textoCancelar='No'
        onConfirm={confirmPopup.onConfirm}
        iconClass="fa fa-exclamation-triangle"
      />
    </ContainerApFacturacion>
  );
};

export default ComponentApFacturacionPlanes;
